<template>
  <div @click="set" class='SearchItem01'>
    <div class="cont-img">
      <img v-if="data.img.length" :src="data.img[0].img">
      <img-icon
      v-if="!data.img.length"
      :options="{ width: '38px', heigth: '38px', color: '#CCCCCC' }"
      />
    </div>
    <div class="cont">
      <div class="desc">{{ data.name }}</div>
      <div class="valor">
        <span :class="{ disabled: isString(data.oferta) > 0 }" style="margin: 5px">{{ data.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
        <span v-if="isString(data.oferta) > 0" style="margin: 5px">{{ data.oferta.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ImgIcon from '@/components/EnbPainel/Icons/ImgIcon'
export default {
  name: 'SearchItem01',
  components: { ImgIcon },
  props: ['data', 'out'],
  emits: ['update:out'],
  methods: {
    ...mapActions(['SetItem01']),
    set () {
      this.SetItem01(this.data)
        .then( async () => {
          if(typeof this.$route.params.categ !== 'undefined') {
            this.$router.push(`/loja/${this.$route.params.categ}/${this.data.link}`)
            this.$emit('update:out', true)
          } else {
            this.$router.push(`/${this.data.link}`)
            this.$emit('update:out', true)
          }
        })
    },
    isString (value) {
      return typeof value === 'string' ? parseFloat(value.replace(/\./g, '').replace('R$ ', '').replace(',', '.')) : value
    }
  }
}
</script>

<style scoped>
.SearchItem01 {
  width: 90%;
  display: flex;
  align-items: center;
  height: 10%;
  margin: auto;
  border-bottom: thin solid #CCCCCC;
  cursor: pointer;
}

.SearchItem01:hover {
  background-color: #EEEEEE;
}

.cont-img {
  width: 20%;
  padding: 2%;
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  width: 40px;
  height: 40px;
}

.cont {
  width: 80%;
  height: 100%;
}

.desc {
  display: flex;
  align-items: center;
  height: 50%;
  text-align: left;
}

.valor {
  width: 100%;
  display: flex;
  align-items: center;
}

.disabled {
  color: #CCCCCC;
  text-decoration: line-through;
}
</style>
